import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "onChange", "onClick", "size", "tabIndex", "className", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { pxToEm, pxToRem, alpha, contrast, getDimmedTextColor } from 'utils/ui';
import { fillParent } from 'styles/mixins';
import { useTabIndexContext } from 'components/TabIndexContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SIZE_MAP = {
  small: {
    box: 18,
    dotSpacing: 3
  },
  default: {
    box: 21,
    dotSpacing: 4
  }
};
var EXTEND_TAP_AREA_SPACING = pxToRem(6);
var Wrapper = styled.span.withConfig({
  displayName: "RadioButton__Wrapper",
  componentId: "sc-1m2ptq4-0"
})(["position:relative;display:inline-flex;"]);
var Input = styled.input.withConfig({
  displayName: "RadioButton__Input",
  componentId: "sc-1m2ptq4-1"
})(["position:absolute;top:-", ";left:-", ";width:calc(100% + ", " * 2);height:calc(100% + ", " * 2);opacity:0;"], EXTEND_TAP_AREA_SPACING, EXTEND_TAP_AREA_SPACING, EXTEND_TAP_AREA_SPACING, EXTEND_TAP_AREA_SPACING);
var MockBox = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isChecked', 'size'].includes(prop);
  }
}).withConfig({
  displayName: "RadioButton__MockBox",
  componentId: "sc-1m2ptq4-2"
})(["position:relative;pointer-events:none;display:inline-flex;align-items:center;justify-content:center;width:", ";height:", ";font-size:", ";color:", ";background:", ";border:1px solid ", ";border-radius:100%;input[disabled] + &{opacity:0.5;", ";}&::before,&::after{content:'';", " opacity:0;transition:opacity 0.25s linear;pointer-events:none;}&::before{background:", ";border-radius:inherit;", ":hover &{opacity:", ";transition-duration:50ms;}}&::after{top:-3px;left:-3px;bottom:-3px;right:-3px;border-radius:inherit;box-shadow:0 0 0 3px ", ";input.focus-visible + &{opacity:1;transition-duration:50ms;}}"], pxToEm(16), pxToEm(16), function (p) {
  return pxToRem(p.size);
}, function (p) {
  return p.isChecked ? p.theme.links : p.theme.background;
}, function (p) {
  return contrast(p.theme.links);
}, function (p) {
  return alpha(p.isChecked ? p.theme.links : p.theme.text, p.isChecked ? 1 : 0.5);
}, function (p) {
  var textColor = getDimmedTextColor(p.theme);
  return css(["border:none;background-image:linear-gradient( 45deg,white 25%,", " 25%,", " 50%,white 50%,white 75%,", " 75%,", " 100% );background-size:4px 4px;"], textColor, textColor, textColor, textColor);
}, fillParent, function (p) {
  return p.theme.shade;
}, Wrapper, function (p) {
  return Math.min(p.theme.shadeStrength, 0.12);
}, function (p) {
  return p.theme.links;
});
var Dot = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isChecked', 'spacing'].includes(prop);
  }
}).withConfig({
  displayName: "RadioButton__Dot",
  componentId: "sc-1m2ptq4-3"
})(["position:absolute;top:0;bottom:0;left:0;right:0;margin:", ";border-radius:100%;background-color:currentColor;opacity:", ";transition:opacity 150ms ease-out;"], function (p) {
  return pxToRem(p.spacing);
}, function (p) {
  return p.isChecked ? 1 : 0;
});
var RadioButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    tabIndex = _ref.tabIndex,
    className = _ref.className,
    style = _ref.style,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var tabIndexContext = useTabIndexContext();
  var isChecked = Boolean(checked);
  return /*#__PURE__*/_jsxs(Wrapper, {
    className: className,
    style: style,
    children: [/*#__PURE__*/_jsx(Input, _objectSpread({
      type: "radio",
      ref: ref,
      checked: isChecked,
      onChange: onChange,
      onClick: onClick,
      tabIndex: tabIndex || tabIndexContext
    }, otherProps)), /*#__PURE__*/_jsx(MockBox, {
      "aria-hidden": "true",
      isChecked: isChecked,
      size: SIZE_MAP[size].box,
      children: /*#__PURE__*/_jsx(Dot, {
        isChecked: isChecked,
        spacing: SIZE_MAP[size].dotSpacing
      })
    })]
  });
});
RadioButton.displayName = 'RadioButton';
export default RadioButton;